import { render, staticRenderFns } from "./TabCotizacion.vue?vue&type=template&id=4537bd0e"
import script from "./TabCotizacion.vue?vue&type=script&lang=js"
export * from "./TabCotizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4537bd0e')) {
      api.createRecord('4537bd0e', component.options)
    } else {
      api.reload('4537bd0e', component.options)
    }
    module.hot.accept("./TabCotizacion.vue?vue&type=template&id=4537bd0e", function () {
      api.rerender('4537bd0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/tasks/validaciones/formalizacionactas/TabCotizacion.vue"
export default component.exports